import { render, staticRenderFns } from "./PersonCardBack.vue?vue&type=template&id=3b572319&scoped=true"
import script from "./PersonCardBack.vue?vue&type=script&lang=js"
export * from "./PersonCardBack.vue?vue&type=script&lang=js"
import style0 from "./PersonCardBack.vue?vue&type=style&index=0&id=3b572319&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b572319",
  null
  
)

export default component.exports